<template>
  <div class="class-1">
    <!-- Header -->
    <div v-if="!fromPos">
    <app-header />
</div>
    <!-- Customer Form -->
    <div class="container mt-4">
      <div class="row">
        <div class="col-12">
          <!-- <h2>New Customer</h2> -->
          <form @submit.prevent="handleRegister">
            <!-- Name Input -->
            <div class="form-row">
              <div class=" col-md-12">
                <label for="name">Name</label>
                <div class="searchbyphone d-flex flex-row">
                  <div class="infobox fieldOuter w-100">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      placeholder="Enter customer name"
                      v-model="form.name"
                      ref="nameInput"
                    >
                  </div>
                  <span class="icon1 icon2" @click="openKeypad('nameInput')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                  </span>
                </div>
              </div>
            </div>

            <!-- Phone Number Input -->
            <div class="form-row">
              <div class=" col-md-12">
                <label for="number">Phone Number</label>
                <div class="searchbyphone d-flex flex-row">
                  <div class="infobox fieldOuter w-100">
                    <input
                      type="text"
                      class="form-control"
                      id="number"
                      placeholder="Enter phone number"
                      v-model="form.phone"
                      ref="phoneInput"
                      required
                    >
                  </div>
                  <span class="icon1 icon2" @click="openKeypad('phoneInput')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M4.5 1a.5.5 0 0 1 .5.5V3h1.5V1.5a.5.5 0 0 1 1 0V3h1V1.5a.5.5 0 0 1 1 0V3h.5a.5.5 0 0 1 0 1H9v1h1.5a.5.5 0 0 1 0 1H9v1h.5a.5.5 0 0 1 0 1H9v1.5a.5.5 0 0 1-1 0V9H7v1.5a.5.5 0 0 1-1 0V9H4.5a.5.5 0 0 1 0-1H6V7H4.5a.5.5 0 0 1 0-1H6V5H4.5a.5.5 0 0 1 0-1H6V1.5a.5.5 0 0 1 .5-.5h-2z"/>
                            <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1zm11 0H3v14h10V1z"/>
                        </svg>
                  </span>
                </div>
              </div>
            </div>

            <!-- Credit Checkbox -->
            <!-- <div class="form-row">
              <div class=" col-md-12">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="credit"
                    v-model="form.credit"
                  >
                  <label class="form-check-label" for="credit">Credit Customer</label>
                </div>
              </div>
            </div> -->

            <!-- Balance Input (shown only if credit is true) -->
            <div class="form-row" v-if="form.credit">
              <div class=" col-md-12">
                <label for="balance">Balance</label>
                <div class="searchbyphone d-flex flex-row">
                  <div class="infobox fieldOuter w-100">
                    <input
                      type="text"
                      class="form-control"
                      id="balance"
                      placeholder="Enter balance amount"
                      v-model="form.balance"
                      ref="balanceInput"
                    >
                  </div>
                  <span class="icon1 icon2" @click="openKeypad('balanceInput')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                  </span>
                </div>
              </div>
            </div>

            <!-- Address Sections -->
            <div class="address-section">
              <h5>Primary Address</h5>
              <div class="form-row">
                <div class=" col-md-12">
                  <label for="title1">Address Title</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="title1"
                        placeholder="Enter address title"
                        v-model="form.addresses[0].title"
                        ref="title1"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('title1')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="area1">Area</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="area1"
                        placeholder="Enter area"
                        v-model="form.addresses[0].area"
                        ref="area1"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('area1')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="street1">Street</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="street1"
                        placeholder="Enter street"
                        v-model="form.addresses[0].street"
                        ref="street1"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('street1')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="build1">Building</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="build1"
                        placeholder="Enter building"
                        v-model="form.addresses[0].build"
                        ref="build1"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('build1')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="floor1">Floor</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="floor1"
                        placeholder="Enter floor"
                        v-model="form.addresses[0].floor"
                        ref="floor1"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('floor1')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="flat1">Flat</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="flat1"
                        placeholder="Enter flat"
                        v-model="form.addresses[0].flat"
                        ref="flat1"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('flat1')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class=" col-md-12">
                  <label for="link1">link</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="link1"
                        placeholder="Enter location link"
                        v-model="form.addresses[0].link"
                        ref="link1"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('link1')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Additional Address 2 -->
            <div class="address-section" v-if="showAddress2">
              <h5>Additional Address 2</h5>
              <div class="form-row">
                <div class=" col-md-12">
                  <label for="title2">Address Title</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="title2"
                        placeholder="Enter address title"
                        v-model="form.addresses[1].title"
                        ref="title2"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('title2')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="area2">Area</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="area2"
                        placeholder="Enter area"
                        v-model="form.addresses[1].area"
                        ref="area2"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('area2')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="street2">Street</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="street2"
                        placeholder="Enter street"
                        v-model="form.addresses[1].street"
                        ref="street2"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('street2')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="build2">Building</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="build2"
                        placeholder="Enter building"
                        v-model="form.addresses[1].build"
                        ref="build2"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('build2')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="floor2">Floor</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="floor2"
                        placeholder="Enter floor"
                        v-model="form.addresses[1].floor"
                        ref="floor2"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('floor2')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="flat2">Flat</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="flat2"
                        placeholder="Enter flat"
                        v-model="form.addresses[1].flat"
                        ref="flat2"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('flat2')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>
               <div class="form-row">
                <div class=" col-md-12">
                  <label for="link2">link</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="link2"
                        placeholder="Enter location link"
                        v-model="form.addresses[1].link"
                        ref="link2"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('link2')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Additional Address 3 -->
            <div class="address-section" v-if="showAddress3">
              <h5>Additional Address 3</h5>
              <div class="form-row">
                <div class=" col-md-12">
                  <label for="title3">Address Title</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="title3"
                        placeholder="Enter address title"
                        v-model="form.addresses[2].title"
                        ref="title3"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('title3')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="area3">Area</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="area3"
                        placeholder="Enter area"
                        v-model="form.addresses[2].area"
                        ref="area3"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('area3')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="street3">Street</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="street3"
                        placeholder="Enter street"
                        v-model="form.addresses[2].street"
                        ref="street3"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('street3')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="build3">Building</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="build3"
                        placeholder="Enter building"
                        v-model="form.addresses[2].build"
                        ref="build3"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('build3')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="floor3">Floor</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="floor3"
                        placeholder="Enter floor"
                        v-model="form.addresses[2].floor"
                        ref="floor3"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('floor3')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class=" col-md-12">
                  <label for="flat3">Flat</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="flat3"
                        placeholder="Enter flat"
                        v-model="form.addresses[2].flat"
                        ref="flat3"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('flat3')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>
               <div class="form-row">
                <div class=" col-md-12">
                  <label for="link3">link</label>
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="link3"
                        placeholder="Enter location link"
                        v-model="form.addresses[2].link"
                        ref="link3"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad('link3')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Add Address Button -->
            <div class="form-row" v-if="!showAddress3">
              <div class=" col-md-12 text-center">
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="addAddress"
                >
                  + Add Another Address
                </button>
              </div>
            </div>

            <!-- Form Buttons -->
            <div class="form-row">
              <div class=" col-12 d-flex justify-content-between">
                <button type="button" class="btn btn-secondary" @click="clearForm">Cancel</button>
                <button type="" class="btn btn-primary">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Keypad 
      ref="keypad"
      :target-input="currentInputRef"
      @update:value="updateInputValue"
      @cancel="closeKeypad"
    />
    <NumericKeypad 
      ref="numericKeypad"
      :target-input="currentInputRef"
      @update:value="updateNumericValue"
      @cancel="closeKeypad"
    />
  </div>
</template>

<script>
import NumericKeypad from './NumericKeypad.vue';
import Keypad from './keypad_popup_component.vue';
import { Modal } from 'bootstrap'; 

export default {
  components: {
    Keypad,
    NumericKeypad
  },
  props: {
  fromPos: {
    type: Boolean,
    default: false
  }
},
  data() {
    return {
      form: {
        name: '',
        phone: '',
        credit: false,
        balance: '',
        addresses: [
          {
            title: 'Home',
            area: '',
            street: '',
            build: '',
            floor: '',
            link: '',
            flat: ''
          },
          {
            title: '',
            area: '',
            street: '',
            build: '',
            floor: '',
            link: '',
            flat: ''
          },
          {
            title: '',
            area: '',
            street: '',
            build: '',
            floor: '',
            link: '',
            flat: ''
          }
        ]
      },
      currentInputRef: null,
      currentInputName: null,
      showAddress2: false,
      showAddress3: false,
      keypadModal: null,
      numberModal: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      const keypadModalElement = this.$refs.keypad?.$el;
      if (keypadModalElement) {
        this.keypadModal = new Modal(keypadModalElement);
      }

      const numericModalElement = this.$refs.numericKeypad?.$el;
      if (numericModalElement) {
        this.numberModal = new Modal(numericModalElement);
      }
    });
  },
  methods: {
    addAddress() {
      if (!this.showAddress2) {
        this.showAddress2 = true;
      } else if (!this.showAddress3) {
        this.showAddress3 = true;
      }
    },
    clearForm() {
      this.$router.push('/customers');
      this.form = {
        name: '',
        phone: '',
        credit: false,
        balance: '',
        addresses: [
          {
            title: 'Home',
            area: '',
            street: '',
            build: '',
            floor: '',
            link: '',
            flat: ''
          },
          {
            title: '',
            area: '',
            street: '',
            build: '',
            floor: '',
            link: '',
            flat: ''
          },
          {
            title: '',
            area: '',
            street: '',
            build: '',
            floor: '',
            link: '',
            flat: ''
          }
        ]
      };
      this.showAddress2 = false;
      this.showAddress3 = false;
    },
    openKeypad(inputRef) {
      this.currentInputRef = this.$refs[inputRef];
      this.currentInputName = inputRef;
      
      if (inputRef === 'phoneInput' || inputRef === 'balanceInput') {
        this.$refs.numericKeypad.setTargetInput(this.$refs[inputRef]);
        this.numberModal.show();
      } else {
        this.$refs.keypad.setTargetInput(this.$refs[inputRef]);
        this.keypadModal.show();
      }
    },
    updateInputValue(value) {
  if (this.currentInputName && this.currentInputRef) {
    this.currentInputRef.value = value;
    
    const path = this.getFormFieldPath(this.currentInputName);
    if (path) {
      const parts = path.split('.');
      let obj = this.form;
      
      for (let i = 0; i < parts.length - 1; i++) {
        obj = obj[parts[i]];
      }
      
      obj[parts[parts.length - 1]] = value;
    }
  }
},
    updateNumericValue(value) {
      if (this.currentInputName === 'phoneInput') {
        this.form.phone = value;
      } else if (this.currentInputName === 'balanceInput') {
        this.form.balance = value;
      }
      this.closeKeypad();
    },
    getFormFieldPath(inputName) {
      // Map input refs to form field paths
      const mapping = {
        nameInput: 'name',
        phoneInput: 'phone',
        balanceInput: 'balance',
        title1: 'addresses.0.title',
        area1: 'addresses.0.area',
        street1: 'addresses.0.street',
        build1: 'addresses.0.build',
        floor1: 'addresses.0.floor',
        flat1: 'addresses.0.flat',
        link1: 'addresses.0.link',
        title2: 'addresses.1.title',
        area2: 'addresses.1.area',
        street2: 'addresses.1.street',
        build2: 'addresses.1.build',
        floor2: 'addresses.1.floor',
        flat2: 'addresses.1.flat',
        link2: 'addresses.1.link',
        title3: 'addresses.2.title',
        area3: 'addresses.2.area',
        street3: 'addresses.2.street',
        build3: 'addresses.2.build',
        floor3: 'addresses.2.floor',
        flat3: 'addresses.2.flat',
        link3: 'addresses.2.link',
      };
      
      return mapping[inputName];
    },
    closeKeypad() {
      if (this.keypadModal) {
        this.keypadModal.hide();
      }
      if (this.numberModal) {
        this.numberModal.hide();
      }
      this.removeBackdrop();
      this.currentInputRef = null;
      this.currentInputName = null;
    },
    removeBackdrop() {
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
      document.body.classList.remove('modal-open');
      document.body.style.paddingRight = '';
    },
   async handleRegister() {
  const addressesToSend = this.form.addresses.filter((addr, index) => {
    if (index === 0) return true;
    return addr.title || addr.area || addr.street || addr.build || addr.floor || addr.flat || addr.link;
  });
  
  const payload = {
    name: this.form.name,
    phone: this.form.phone,
    registration_date: new Date().toISOString().split('T')[0],
    credit: this.form.credit,
    balance: Number(this.form.balance) || 0,
    addresses: addressesToSend
  };
  
  try {
    this.$root.isLoading = true; 
    const token = localStorage.getItem('authToken');

    const response = await fetch(`${this.$BASE_API_URL}/api/customers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (response.ok) {
      this.$toast.success('Registration successful!');
      this.$emit('customer-added', );
      // Check if we came from POS and redirect accordingly
      if (this.fromPos) {
        // this.$router.push('/pos');
      } else {
        this.$router.push('/customers');
      }
    } else {
      // Handle validation errors
      let errorMessage = data.message || 'Registration failed';
      this.$emit('cancel');
      if (data.errors) {
        const firstErrorKey = Object.keys(data.errors)[0];
        if (firstErrorKey && data.errors[firstErrorKey][0]) {
          errorMessage = data.errors[firstErrorKey][0];
        }
      } else if (data.error?.message) {
        errorMessage = data.error.message;
      }
      
      this.$toast.error(errorMessage);
    }
  } catch (error) {
    console.error('Error:', error);
    this.$toast.error('An error occurred. Please try again.');
  } finally {
    this.$root.isLoading = false;
  }
}
  }
};
</script>

<style scoped>
.address-section {
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #dee2e6;
}

.searchbyphone {
  position: relative;
}

.infobox.fieldOuter {
  position: relative;
  width: 100%;
}

.icon1.icon2 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 38px;
  border: 1px solid #ced4da;
  border-left: none;
  cursor: pointer;
  border-radius: 0 4px 4px 0;
}

.icon1.icon2 svg {
  width: 20px;
  height: 20px;
  fill: #495057;
}

.form-control {
  border-radius: 4px 0 0 4px !important;
}

.btn-outline-secondary {
  border: 1px dashed #6c757d;
  color: #6c757d;
  transition: all 0.3s;
}

.btn-outline-secondary:hover {
  border-style: solid;
  background-color: rgba(108, 117, 125, 0.1);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .container {
    padding: 15px;
  }
  
  .address-section {
    padding: 15px;
  }
}
</style>